import type { LocalCategory, LocalProductWithStock } from '@shared/offline';
import type { ProductCategory, ProductWithStock } from '../domain/models';

const DEFAULT_CURRENCY = 'TND';
const epoch = new Date(0);

export function mapLocalCategoryToDomain(category: LocalCategory): ProductCategory {
  return {
    id: category.visibleId,
    name: category.name,
    isActive: category.isActive,
    isFreeSaleOrService: category.isFreeSaleOrService,
    isFreePrice: category.isFreePrice,
    productsCount: category.productsCount,
    createdAt: epoch,
    updatedAt: epoch,
  };
}

export function mapLocalProductToDomain(
  product: LocalProductWithStock,
  branchId: string,
): ProductWithStock {
  const stock = product.stock;
  const exposedOnSite = product.exposedOnSite;
  return {
    id: product.visibleId,
    name: product.name,
    sku: product.sku,
    barcode: product.barcode ?? undefined,
    description: product.description ?? undefined,
    salePriceHT: product.salePriceHT,
    currency: DEFAULT_CURRENCY,
    taxRate: product.taxRate,
    categoryId: product.categoryId,
    isActive: product.isActive,
    createdAt: epoch,
    updatedAt: epoch,
    branchStock: {
      branchId,
      stock,
      exposedOnSite,
      reservedStock: 0,
      availableStock: product.availableStock,
      minimumStock: 10,
    },
  };
}

export function mapLocalCategoriesToDomain(categories: LocalCategory[]): ProductCategory[] {
  return categories.map(mapLocalCategoryToDomain);
}

export function mapLocalProductsToDomain(
  products: LocalProductWithStock[],
  branchId: string,
): ProductWithStock[] {
  return products.map((p) => mapLocalProductToDomain(p, branchId));
}
